import React from 'react';


const About  = () => {
  return (
    <div name='about' className='w-full h-screen bg-[#6a0dff] text-gray-300'>
      <div className='flex flex-col justify-center items-center w-full h-full'>
        <div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
          <div className='sm:text-right pb-8 pl-4'>
            <p className='text-6xl font-bold inline border-b-4 border-pink-600'>
              About Us
            </p>
          </div>
          </div>
          <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
            <div className='sm:text-right text-4xl font-bold'>
              <p>A team of dedicated individuals</p>
            </div>
            <div>
              <p className='text-xl'>// It's no secret, we love what we do.<br />We're a small team of developers based out of Quebec Canada with a user friendly approach to bringing your ideas to the world. //<br /></p>  
            </div>
          </div>
      </div>
    </div>
  );
};

export default About;
